// src/hooks/useUser.ts
import { useState, useCallback, useMemo } from 'react';

export const useUser = () => {
  const [currentUser, setCurrentUser] = useState<User | null>(() => {
    try {
      const storedUser = localStorage.getItem('user');
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error('Failed to parse user from localStorage', error);
      return null;
    }
  });

  const updateUser = useCallback((newUserData: User) => {
    console.log('updateUser chamado', newUserData);

    // 🔹 Persistência e atualização de estado
    localStorage.setItem('user', JSON.stringify(newUserData));
    setCurrentUser(newUserData);
  }, []);

  const user = useMemo(() => currentUser, [currentUser]);

  return { user, updateUser };
};
